var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13,0,2.161,10.853,0,13.014l2.161,2.161L13,26.014l2.161-2.156L5.85,14.542H29.932V11.486H5.85l9.316-9.32Z"}));
}

ArrowLeft.defaultProps = {"width":"29.932","height":"26.014","viewBox":"0 0 29.932 26.014"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
